import {Component, Input, OnInit} from '@angular/core';
import {GetRicaricaView} from "../../../../api-clients/generated/services";
import { IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonText, IonAccordionGroup, IonAccordion, ModalController } from '@ionic/angular/standalone';


@Component({
    selector: 'app-dettaglio-ricarica-modal',
    templateUrl: './dettaglio-ricarica-modal.component.html',
    styleUrls: ['./dettaglio-ricarica-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonText, IonAccordionGroup, IonAccordion]
})
export class DettaglioRicaricaModalComponent  implements OnInit {
  currentRicarica: GetRicaricaView = {}
  modalTitle: string = 'DETTAGLIO RICARICA';

  @Input() set ricarica(ricarica: GetRicaricaView) {
    this.currentRicarica = ricarica;

  }
  constructor( private modalController: ModalController,) { }

  ngOnInit() {}

  joinOperazioni(array?: Array<string>) {
    if(!!array && array.length > 0) {
      return array.join(', ')
    } else {
      return ''
    }
  }

  goToBack() {
    this.modalController.dismiss().then(r => console.log('Dettaglio ricarica dismiss'))
  }
}
